export default __webpack_public_path__ + "static/media/agent-illu.10c83016.png";